export default class BulkActions {
  static FULL_UPDATE = "fullUpdate";

  static CHANGE_PATH = "changePath";

  static CHANGE_REASON = "changeReason";

  static CHANGE_STATUS = "changeStatus";

  static ADD_TAGS = "addTags";

  static LINK_VENDOR = "linkVendor";

  static SELECT_CATEGORY = "selectCategory";

  static SELECT_ITEM = "selectItem";

  static SELECT_CLASS = "selectClass";

  static SELECT_LOCATION = "selectLocation";

  static SELECT_PROJECT = "selectProject";

  static SELECT_TAX_RATE = "selectTaxRate";

  static SELECT_PAYMENT_ACCOUNT = "selectPaymentAccount";

  static RESET_AND_REDO = "resetAndRedo";

  static REMOVE = "remove";
}
